import React from 'react'

import './styles.scss'

import { IntroProps } from '../types'

import backgroundImg from './img/background.jpg'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

const Intro = ({
  coupleData: { coupleSimplifiedName, weddingDate },
  buttonMessage,
  warningMessage,
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  const text =
    new Date() > new Date(weddingDate.timestamp)
      ? 'JÁ SE CASARAM!'
      : 'VÃO SE CASAR!'
  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro276">
      <div className="intro276mobile screen">
        <img
          className="main-background-KLFY82"
          src={background || backgroundImg}
        />
        <div className="mask-KLFY82"></div>
        <div className="container-center-horizontal">
          <div className="button-KLFY82">
            <p
              className="site-de-casamento-e-nY2Qge"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <button type="button" className="button-nY2Qge">
              <div className="pular-introduo-pgZumI" onClick={onSkipIntro}>
                {buttonMessage}
              </div>
            </button>
          </div>
        </div>
        <div className="container-center-vertical container-center-horizontal">
          <div className="content-KLFY82">
            <div className="stacked-group-hy0xrY">
              <svg
                className="asterisc-UU0H4G bp2-intro276-animate-enter3"
                viewBox="0 0 16 18"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="m9.12 7.05 6.24-3.32c.45.05.75.63.6 1.1l-5.74 4.22 5.7 4.17c.14.47-.1 1.1-.6 1.16l-6.2-3.43-.5 6.85c-.3.27-.9.27-1.2 0l-.54-6.85-6.2 3.43c-.44-.06-.74-.69-.6-1.16l5.7-4.17L.04 4.84c-.15-.48.15-1.06.6-1.11l6.24 3.32L7.43.2c.3-.27.84-.27 1.2 0l.5 6.85Z"
                  fill="#FFF"
                  fillRule="evenodd"
                />
              </svg>
              <div className="notranslate couple-simplified-nam-UU0H4G bp2-intro276-animate-enter2">
                {coupleSimplifiedName.bride}
                {coupleSimplifiedName.groom &&
                  ` & ${coupleSimplifiedName.groom}`}
              </div>

              <svg
                className="asterisc-jx8MA9 bp2-intro276-animate-enter1"
                viewBox="0 0 16 18"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="m9.12 7.05 6.24-3.32c.45.05.75.63.6 1.1l-5.74 4.22 5.7 4.17c.14.47-.1 1.1-.6 1.16l-6.2-3.43-.5 6.85c-.3.27-.9.27-1.2 0l-.54-6.85-6.2 3.43c-.44-.06-.74-.69-.6-1.16l5.7-4.17L.04 4.84c-.15-.48.15-1.06.6-1.11l6.24 3.32L7.43.2c.3-.27.84-.27 1.2 0l.5 6.85Z"
                  fill="#FFF"
                  fillRule="evenodd"
                />
              </svg>
            </div>
            <div className="vo-se-casar-hy0xrY bp2-intro276-animate-enter">
              {text}
            </div>
          </div>
        </div>
      </div>
      <div className="intro276desktop screen">
        <img
          className="main-background-MfBpCD"
          src={background || backgroundImg}
        />
        <div className="mask-MfBpCD"></div>
        <div className="container-center-horizontal">
          <div className="button-MfBpCD">
            <p
              className="site-de-casamento-e-w7xvR9"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <button type="button" className="button-w7xvR9">
              <div className="pular-introduo-5DjJmL" onClick={onSkipIntro}>
                {buttonMessage}
              </div>
            </button>
          </div>
        </div>
        <div className="container-center-vertical container-center-horizontal">
          <div className="content-MfBpCD">
            <div className="stacked-group-tSX3h0">
              <svg
                className="asterisc-9s9VxA bp1-intro276-animate-enter3"
                viewBox="0 0 16 18"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="m9.12 7.05 6.24-3.32c.45.05.75.63.6 1.1l-5.74 4.22 5.7 4.17c.14.47-.1 1.1-.6 1.16l-6.2-3.43-.5 6.85c-.3.27-.9.27-1.2 0l-.54-6.85-6.2 3.43c-.44-.06-.74-.69-.6-1.16l5.7-4.17L.04 4.84c-.15-.48.15-1.06.6-1.11l6.24 3.32L7.43.2c.3-.27.84-.27 1.2 0l.5 6.85Z"
                  fill="#FFF"
                  fillRule="evenodd"
                />
              </svg>
              <h1 className="notranslate couple-simplified-nam-9s9VxA bp1-intro276-animate-enter2">
                {coupleSimplifiedName.bride}
                {coupleSimplifiedName.groom &&
                  ` & ${coupleSimplifiedName.groom}`}
              </h1>

              <svg
                className="asterisc-ndR05C bp1-intro276-animate-enter1"
                viewBox="0 0 16 18"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="m9.12 7.05 6.24-3.32c.45.05.75.63.6 1.1l-5.74 4.22 5.7 4.17c.14.47-.1 1.1-.6 1.16l-6.2-3.43-.5 6.85c-.3.27-.9.27-1.2 0l-.54-6.85-6.2 3.43c-.44-.06-.74-.69-.6-1.16l5.7-4.17L.04 4.84c-.15-.48.15-1.06.6-1.11l6.24 3.32L7.43.2c.3-.27.84-.27 1.2 0l.5 6.85Z"
                  fill="#FFF"
                  fillRule="evenodd"
                />
              </svg>
            </div>
            <div className="vo-se-casar-tSX3h0 bp1-intro276-animate-enter">
              {text}
            </div>
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
